import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import {BASE_URL} from "../Apis/apiConfig";

const MemberReceipt = () => {
  const location = useLocation();
  const rawData = location.state?.record?.[0] || {};
  const pdfRef = useRef();
  const society = localStorage.getItem("society")

  const handlePrint = useReactToPrint({
    content: () => pdfRef.current,
    documentTitle: `Receipt_${rawData.receiptNo || "Download"}`,
  });

  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <button onClick={handlePrint} style={{
          padding: "8px 16px",
          fontSize: "14px",
          backgroundColor: "#4CAF50",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer"
        }}>
          Download PDF
        </button>
      </div>
      <div
        ref={pdfRef}
        style={{
          width: "800px",
          margin: "auto",
          padding: "20px",
          border: "1px solid black",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px",
          backgroundColor: "#fff",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <h2 style={{ margin: "0", fontSize: "18px" }}>
            {society}
          </h2>
          <div style={{ fontSize: "13px" }}>
            Registration No. MUM/WR/HSG/TC/14358/2008-09/YEAR09 Dated:
            <br />
            Lokhandwala Township, Akurli Road, Kandivali-East, Mumbai- 400101.
            Phone Number: +91-22- 49617431
          </div>
          <h3 style={{ marginTop: "10px" }}>RECEIPT</h3>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
          <div>
            <strong>Receipt No. :</strong> {rawData.receiptNo || '—'}
          </div>
          <div>
            <strong>Date :</strong> {rawData.date || '—'}
          </div>
        </div>

        <div style={{ marginBottom: "5px" }}>
          <strong>Received with Thanks From :</strong> {rawData.name || '—'}
        </div>

        <div style={{ marginBottom: "5px" }}>
          <strong>Unit No. :</strong> {rawData.unitNo || '—'}
        </div>

        <div style={{ marginBottom: "5px" }}>
          <strong>₹</strong> {rawData.amount || '0.00'}
        </div>

        <div style={{ marginBottom: "5px" }}>
          <strong>Sum of :</strong> ( {rawData.amountInWords || 'Rupees ... Only'} )
        </div>

        <div style={{ marginBottom: "5px" }}>
          <strong>towards</strong>  {rawData.billNo || '—'}, Bill Date: {rawData.billDate || '—'}
          {rawData.period ? ` For ${rawData.period}` : ''}
        </div>

        <div style={{ marginBottom: "5px" }}>
          <strong>By Cheque No. :</strong> {rawData.chequeNo || '—'} &nbsp;&nbsp;
          <strong>Dated On :</strong> {rawData.chequeDate || '—'} &nbsp;&nbsp;
          <strong>Online :</strong> {rawData.isOnline ? 'Yes' : 'No'}
        </div>

        <div style={{ marginBottom: "40px" }}>
          <strong>Drawn on :</strong> {rawData.drawnOn || ''}
        </div>

        <div style={{ textAlign: "right", marginBottom: "60px" }}>
          For {society}
        </div>

        <div style={{ textAlign: "right", marginBottom: "10px" }}>
          <strong>Authorised Signatory</strong>
        </div>

        <div style={{ fontSize: "12px" }}>
          This Receipt is Valid Subject to realisation of cheque..
        </div>
      </div>
    </div>
  );
};

export default MemberReceipt;
